
<error-error-content 
  image="assets/img/images/error-images/image3.png"
  errorType="REQUEST_TIMED_OUT"
  copy="ERROR_408"></error-error-content>


